/** @format */

import React, { Suspense, useContext } from "react";

// for fancy animation through the app 
import "aos/dist/aos.css";
//import Aos from "aos";
// Tosty tosty notificacion
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Route, Switch } from "react-router-dom";

//State manager
import { UiContext } from "./stateManagement/context/UiContext";
import Loading from "./common/LoadingScreens/Loading";
import Search from "./common/Search";
import FloatingMenu from "./components/floatingMenu/floatingMenu";
// import FullScreenModal from "./common/modals/FullScreenModal";
import ScrollToTop from "./common/ScrollToTop";
import NewsScreen from "./screens/NewsScreen";
import ViewNewsScreen from "./screens/ViewNewsScreen";
import NoMoni from "./ad/NoMoni";
//code spillitting for  performance purposes

const BookmarkScreen = React.lazy(() => import("./screens/BookmarkScreen"));
const TitleScreen = React.lazy(() => import("./screens/TitleScreen"));
const Home = React.lazy(() => import("./screens/Home"));
const PrivacyPolicy = React.lazy(() => import("./screens/PrivacyPolicy"));
const TermsAndConditions = React.lazy(() =>
	import("./screens/TermsAndConditions")
);
const ViewGenreScreen = React.lazy(() => import("./screens/ViewGenreScreen"));
const NotFound = React.lazy(() => import("./screens/NotFound"));
const ViewScreen = React.lazy(() => import("./screens/ViewScreen"));
const ContactUs = React.lazy(() => import("./screens/ContactUs"));
const LoginScreen = React.lazy(() => import("./screens/LoginScreen"));
const AboutUs = React.lazy(() => import("./screens/AboutUs"));
function App() {
	//for fancy animation through the app
	// React.useEffect(() => {
	// 	Aos.init({
	// 		duration: 250,
	// 	});
	// }, []);
	const { uiState } = useContext(UiContext);
	//const [model, setModel] = React.useState(localStorage.getItem("model"));

	return (
		<div className="relative">
			<Suspense fallback={<Loading />}>
				{/* {model === null ? <FullScreenModal setModel={setModel} /> : null} */}
				<NoMoni />
				<div id="top-view" className={uiState.isDarkMode ? "dark  " : null}>
					<ScrollToTop />
					<ToastContainer
						position="top-right"
						autoClose={4000}
						hideProgressBar
						newestOnTop={false}
						closeOnClick
						rtl={false}
						pauseOnFocusLoss
						draggable
						limit={2}
						pauseOnHover
						theme={uiState.isDarkMode ? "dark" : "light"}
					/>
					<FloatingMenu />

					<Switch>
						<Route path="/" component={Home} exact />
						<Route path="/anime/:id/:name" exact component={ViewScreen} />
						<Route path="/title/:id" exact component={TitleScreen} />
						<Route path="/genre/:id/:genre" exact component={ViewGenreScreen} />
						<Route path="/privacyPolicy" component={PrivacyPolicy} exact />
						<Route path="/news/anime/" component={NewsScreen} exact />
						<Route path="/view/news/:id" component={ViewNewsScreen} exact />
						<Route
							path="/termsAndConditions"
							component={TermsAndConditions}
							exact
						/>
						<Route path="/search" exact component={Search} />
						<Route path="/about" exact component={AboutUs} />
						<Route path="/contact" exact component={ContactUs} />
						<Route path="/auth/login" exact component={LoginScreen} />
						<Route path="/dev/:id" component={Loading} />
						<Route path="/bookmarks" component={BookmarkScreen} />
						{/* <Route path="/auth/register" exact component={RegisterScreen} /> */}

						<Route component={NotFound} />
					</Switch>
				</div>
			</Suspense>
		</div>
	);
}

export default App;
